// extracted by mini-css-extract-plugin
module.exports = {"spinner":"FlowSpinner_spinner__R6CBw","spin":"FlowSpinner_spin__D2ug8"};